/* -----------------Globals--------------- */
import {
	type MaterialTopTabNavigationEventMap,
	type MaterialTopTabNavigationOptions,
	createMaterialTopTabNavigator,
} from "expo-router/js-top-tabs";
import type {
	ParamListBase,
	StackNavigationState,
} from "expo-router/react-navigation";

/* -----------------Helpers & Hooks--------------- */
import { withLayoutContext } from "expo-router";

const { Navigator } = createMaterialTopTabNavigator();

export const MaterialTopTabs = withLayoutContext<
	MaterialTopTabNavigationOptions,
	typeof Navigator,
	StackNavigationState<ParamListBase>,
	MaterialTopTabNavigationEventMap
>(Navigator);
